import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../../helpers';
import TextField from './TextField';
import { AppContextProvider } from '../../../Services/AppContext';

loadDOMComponent({
	selector: 'react-text-field',
	callback: ({ container }) => {
		const name = container.getAttribute('name');
		const placeholder = container.getAttribute('placeholder');
		const value = container.getAttribute('value');
		const netteRules = container.getAttribute('data-nette-rules');
		let required = container.getAttribute('required');
		required = required !== false && required !== null;

		const handleChange = function (tempValue) {};

		ReactDOM.render(
			<AppContextProvider>
				<TextField
					onChange={handleChange}
					type='text'
					name={name}
					placeholder={placeholder}
					value={value}
					required={required}
					data-nette-rules={netteRules}
				/>
			</AppContextProvider>,
			container,
		);
	},
});
